import { createAsyncThunk } from "@reduxjs/toolkit";
import { getRequest, patchRequest, postRequest, deleteRequest } from "../../services/API";

const FETCH_ADMIN_POLICY_DETAILS = "fetchAdminPolicyAction";
const EDIT_ADMIN_POLICY_DETAILS = "editAdminPolicyAction";
const ADD_ADMIN_POLICY_DETAILS = "addAdminPolicyAction";
const DELETE_ADMIN_POLICY_DETAILS = "deleteAdminPolicyAction";

export const fetchAdminPolicyAction = createAsyncThunk(
  FETCH_ADMIN_POLICY_DETAILS,
  async ({ language, isAdmin }) => {
    try {
      let fetchPolicyResult = await getRequest(
        language,
        "policyService",
        isAdmin
      );
      return fetchPolicyResult;
    } catch (error) {
      return JSON.parse(error.message);
    }
  }
);

export const editAdminPolicyAction = createAsyncThunk(
  EDIT_ADMIN_POLICY_DETAILS,
  async ({ language, requestInfo }, { rejectWithValue }) => {
    try {
      let editAdminPolicyResult = await patchRequest(
        language,
        "policyService",
        requestInfo,
        true
      );
      return editAdminPolicyResult;
    } catch (error) {
      return rejectWithValue(JSON.parse(error.message));
    }
  }
);

export const addAdminPolicyAction = createAsyncThunk(
  ADD_ADMIN_POLICY_DETAILS,
  async ({ language, requestInfo }, { rejectWithValue }) => {
    try {
      let addAdminPolicyResult = await postRequest(
        language,
        "policyService",
        requestInfo,
        true
      );
      return addAdminPolicyResult;
    } catch (error) {
      return rejectWithValue(JSON.parse(error.message));
    }
  }
);

export const deleteAdminPolicyAction = createAsyncThunk(
  DELETE_ADMIN_POLICY_DETAILS,
  async ({ language, policyId }, { rejectWithValue }) => {
    try {
      let deleteAdminPolicyResult = await deleteRequest(
        language,
        "policyService",
        policyId,
        true,
        "Business Action deleted!!"
      );
      return deleteAdminPolicyResult;
    } catch (error) {
      return rejectWithValue(JSON.parse(error.message));
    }
  }
);
